import CryptoJS from "crypto-js";

const encryption_key = "Samvedna#7$*23%@51!6^&#";

export const encryption = (id) =>
  CryptoJS.AES.encrypt(id, encryption_key).toString();

export const decryption = (enc_id) =>
  CryptoJS.AES.decrypt(enc_id, encryption_key).toString(CryptoJS.enc.Utf8);
